<template>
  <div class="navbar" style="height: 56px">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />
    <breadcrumb class="breadcrumb-container" />
    <div class="frame">
      <el-select
        v-model="projectId"
        :style="style"
        filterable
        :placeholder="$t('public.pleaseChoose')"
        @visible-change="changeVisible"
        @change="handleCommand"
      >
        <el-option v-for="item in currentProjectList" :key="item.id" style="min-width: 50px" :label="item.projectName" :value="item.id">
          <span v-if="item.isStar === true" class="el-icon-star-on star-icon" />
          <span v-if="item.isTest === true">「测试」</span>
          <span style="float: inherit">{{ item.projectName }}</span>
        </el-option>
      </el-select>
      <svg-icon icon-class="project" class="project-entrance" @click="$router.push({ path: '/user/accountSetting' })" />
    </div>

    <div class="right-menu">
      <div :title="$t('setting.warningManage')">
        <svg-icon icon-class="warning" class="analyse_warning" style="font-size: 22px" @click="warningList" />
      </div>

      <svg-icon icon-class="tenant" style="margin-right: 12px; font-size: 30px" />
      <div>
        <div class="title">{{ $t('public.platform') }}</div>
        <div class="avatar-wrapper">
          <span><span v-if="currentTenantType === 'platform'" style="font-size: 14px; color: #606266">「平台」</span>{{ currentTenantName }}</span>
        </div>
      </div>
      <div class="splitLine"></div>
      <el-popover v-model="visible" :width="isActive == 'zh' ? '140' : '180'" popper-class="popperOptions" trigger="click" placement="top">
        <div class="popover_content">
          <div class="nav-list" @click="$router.push({ path: '/login/tenant' })">
            {{ $t('navbar.changeTenant') }}
          </div>
          <div class="nav-list" @click="$router.push({ path: '/login/accountSetting' })">
            {{ $t('navbar.accountSetting') }}
          </div>
          <el-popover placement="left" popper-class="popperOptions" width="200" trigger="hover">
            <div class="popover_column_right">
              <div
                v-for="(items, idx) in Language"
                :key="idx"
                class="popover_item"
                :class="[isActive === items.type ? 'default-active' : '']"
                @click="language(items.type)"
              >
                {{ items.name }}
              </div>
            </div>
            <div slot="reference" class="nav-list">
              {{ $t('public.chineseEnglish') }}
              <i class="el-icon-arrow-right fl"></i>
            </div>
          </el-popover>
          <div class="nav-list" @click="logout()">
            {{ $t('navbar.logOut') }}
          </div>
        </div>

        <div slot="reference" class="avatar-wrapper" style="display: flex; align-items: center; height: 56px">
          <div slot="reference" style="display: flex">
            <svg-icon icon-class="user-name" style="margin-right: 12px; font-size: 30px" />
            <div>
              <div class="title">{{ $t('public.systemUser') }}</div>
              <span>{{ currentName() }}</span>
            </div>
          </div>
          <svg-icon slot="reference" icon-class="open" style="font-size: 14px; margin: 0px 20px 0" />
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@C/Breadcrumb'
import Hamburger from '@C/Hamburger'
import api from '@/api'
import { removeItem } from '@/utils/pagePath'
export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  data() {
    return {
      Language: [
        {
          name: '中文',
          type: 'zh'
        },
        {
          name: 'English',
          type: 'en'
        }
      ],
      visible: false,
      activeIndex2: '1',
      projectId: '',
      style: {
        width: '50px'
      },
      isActive: '',
      actionActive: '/tenant',
      myChildFalse: ''
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'name',
      'currentUser',
      'currentTenantName',
      'currentTenantType',
      'currentProjectName',
      'currentProjectId',
      'currentProjectList'
    ])
  },
  async mounted() {
    await this.initData()
    this.projectId = this.currentProjectId
    this.style.width = this.getTextWidth(this.currentProjectName)
    this.isActive = this.$store.getters.language
  },
  methods: {
    language(lang) {
      this.$i18n.locale = lang
      this.$ests.event({
        event_name: '选择语言',
        event_param: {
          language: lang
        }
      })
      this.$store.dispatch('app/setLanguage', lang)
      this.$message({
        message: 'Switch Language Success',
        type: 'success'
      })
    },
    commandSetting(commandName) {
      this.$ests.event({
        event_name: '选择用户设置',
        event_param: {
          option: commandName
        }
      })
    },
    changeVisible(flag) {
      if (!flag) {
        return
      }
      this.$ests.event({
        event_name: '展开项目列表'
      })
    },
    changeVisibleSetting(flag) {
      if (!flag) {
        return
      }
      this.$ests.event({
        event_name: '展开用户设置'
      })
    },
    warningList() {
      this.$ests.event({
        event_name: '预警管理'
      })
      this.$router.push({
        path: '/overview/warning_manage/list'
      })
    },
    getTextWidth(str) {
      let span = document.getElementById('__getwidth')
      if (span == null) {
        span = document.createElement('span')
        span.id = '__getwidth'
        document.body.appendChild(span)
        span.style.visibility = 'hidden'
        span.style.whiteSpace = 'nowrap'
      }
      span.innerText = str
      return span.offsetWidth + 50 + 'px'
    },
    async handleCommand() {
      let projectName = ''
      for (const pro of this.currentProjectList) {
        if (pro.id === this.projectId) {
          projectName = pro.projectName
        }
      }
      this.$ests.event({
        event_name: '选择项目',
        event_param: {
          projectName: projectName
        }
      })
      localStorage.removeItem('appKey')
      const param = {
        id: this.projectId,
        projectName: projectName
      }
      await this.$store.dispatch('org/setProject', param)
      window.location.reload()
    },
    async initData() {
      const r = await api.project.userList()
      await this.$store.dispatch('org/setProjectList', r.data)
      if (!this.currentProjectName && this.currentProjectList.length > 0) {
        await this.$store.dispatch('org/setProject', this.currentProjectList[0])
      }
    },
    currentName() {
      if (this.currentUser.name) {
        return this.currentUser.name
      }

      return this.currentUser.username
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      removeItem()
      await this.$store.dispatch('user/logout')
      await this.$store.dispatch('org/reSetProject')
      this.$router.push(`/login?redirect=/login/tenant`)
    }
  }
}
</script>

<style lang="scss">
.el-popper.popperOptions {
  padding: 0 !important;
}
</style>

<style lang="scss" scoped>
.popover_column_right {
  min-width: 120px;
  color: #333333;
  border-right: 1px solid #f0f2f5;
  .default-active {
    color: #489de5;
  }
  .popover_item {
    line-height: 40px;
    height: 40px;
    padding-left: 20px;
  }
  .popover_item:hover {
    color: #489de5;
    cursor: pointer
  }
}

.popover_content {
  .fl {
    float: right;
    line-height: 40px;
  }
  .nav-list {
    text-align: center;
    line-height: 40px;
    height: 40px;
    padding: 0 20px;
  }
  .nav-list:hover {
    text-align: center;
    line-height: 40px;
    height: 40px;
    color: #489de5;
    cursor: pointer
    // background: #489DE5;
  }
}

.demonstration {
  display: block;
  color: #8492a6;
  font-size: 14px;
  margin-bottom: 20px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
/deep/ .el-select input {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 0px solid #dcdfe6 !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  /*min-width: 50px;*/
}

/deep/ .el-select .el-input__suffix {
  right: 15px !important;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}

.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  background-image: url('../../assets/image/table.png');
  background-color: #f5fbff;
  background-size: 100% 100%;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .frame{
    display: inline-flex;
    margin-left: 30px;
    align-items: center;
    height: 100%;
    .project-entrance{
      cursor: pointer;
      font-size: 22px;
      margin-left: 10px;
      &:hover{
        background: rgba(0,0,0,0.1);
        border-radius: 5px;
      }
    }
  }

  .hamburger-container {
    line-height: 56px !important;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    display: flex;
    align-items: center;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 12px;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .splitLine {
      border-left: 2px solid #f0f2f5;
      height: 30px;
      margin: 0 30px;
    }
    .title {
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #adaeae;
    }

    .avatar-container {
      .avatar-wrapper {
        position: relative;
        font-size: 16px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #333333;
        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          bottom: 0px;
        }
      }
    }
  }
}

.star-icon {
  float: left;
  color: #ffbe00;
  margin-top: 10px;
  margin-right: 5px;
}

.analyse_warning {
  margin-right: 20px;
}
.analyse_warning:hover {
  cursor: pointer;
}
</style>
